import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Backbone → React: it's a people problem after all ?",
  "description": "",
  "published": "2016-09-21T00:00:00.000Z",
  "redirect_from": ["/blog/backbone-%e2%86%92-react-its-a-people-problem-after-all-%f0%9f%98%91/swizec/7049"],
  "categories": "backbone, backbonejs, Front End, react, reactjs, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The Big Scary Refactor™, turning a largish, hard-to-manage Backbone app into an easier to manage React app… it got off to a `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/backbone-react-step-1/swizec/7042"
      }}>{`great start yesterday`}</a>{`. Today, not so much.`}</p>
    <p>{`First of all, I realized that our problem isn’t Backbone. The problem is that our UI is not a function of state. It’s an expression of state `}<em parentName="p">{`and a sequence of user actions`}</em>{`.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Starting to realize our problem isn't Backbone. Our problem is that I didn't enforce the UI-as-expression-of-data rule well enough.`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/778300885017296896"
      }}>{`September 20, 2016`}</a></blockquote>
    <p>{`To give you a simple example, we use this pattern a lot:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`class Thing extends Backbone.View {
    constructor() {
        this.events {
            "click button": "toggleActive"
        }
    }

    toggleActive() {
        if (checkSomething) {
            this.$('button').addClass('active');
        }else{
            this.$('button').removeClass('active');
        }
    }
}
`}</code></pre>
    <p>{`This is a trivial Backbone view. It listens for a `}<inlineCode parentName="p">{`click`}</inlineCode>{` event on a `}<inlineCode parentName="p">{`<button>`}</inlineCode>{`. When a click happens, it either adds or removes an `}<inlineCode parentName="p">{`active`}</inlineCode>{` class on that button.`}</p>
    <p>{`Our real views do the same sort of thing, but on a grander scale. It might seem harmless enough, but if your code has this pattern, you can’t reliably wrap Backbone views in React components. You’d have to replay all user interaction on every re-render.`}</p>
    <p>{`That’s a no-go.`}</p>
    <p>{`A better approach, which we follow most of the time (but of course not all of the time), is to move that `}<inlineCode parentName="p">{`checkSomething`}</inlineCode>{` into the View’s backing Model. Something like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`class Thing extends Backbone.View {
    constructor() {
        this.events {
            "click button": "toggleActive"
        }
        this.model = new Backbone.Model({active: false});
        this.listenTo(this.model, 'change', this.render);

        this.template = Handlebars.compile('<button class={{#if active}}active{{/if}}>Button</button>');
    }

    toggleActive() {
        this.model.set('active', !this.model.get('active'));
    }

    render() {
        this.$el.html(this.template(this.model.attributes));
    }
}
`}</code></pre>
    <p>{`Now the UI is an expression of state and user actions manipulate that state instead of the UI. You can re-render as much as you want, and your UI will look correct.`}</p>
    <hr></hr>
    <p>{`But why re-render in the first place? Because it’s the easiest way to deal with data changes from above.`}</p>
    <p>{`We’re moving towards a modern unidirectional data flow architecture where application state lives in a central Redux or MobX store. Right now, it’s scattered through a bunch of Backbone Models living inside each View individually. Then they interact.`}</p>
    <p>{`It’s a mess. Did I mention we have untraceable heisenbugs? Many.`}</p>
    <p>{`If you want unidirectional, then The Central Store is your single source of truth. That means that when new state comes down from the top, you follow.`}</p>
    <p>{`With a React component, your props change, React calls `}<inlineCode parentName="p">{`render()`}</inlineCode>{`, and your UI updates.`}</p>
    <p>{`When your React component is just a thin wrapper for a Backbone View, well… then you have a choice. Update the view’s internal model and hope for the best, or throw the view away and render a new one… and once again hope for the best.`}</p>
    <p>{`There’s a lot of hoping for the best, but I think the “throw away and re-render” is going to be easier to deal with in the long run. It’s also better when we go through the process and all those child Backbone Views eventually become proper React components.`}</p>
    <p>{`Replaying user interaction to `}<em parentName="p">{`exactly`}</em>{` match UI on re-render? Yeah, fuck that. That’s not gonna work with either strategy. ?`}</p>
    <p>{`Ok, so we have our first tradeoff: To avoid UI staleness, we’re going to have UI that forgets user interactions.`}</p>
    <p>{`Such is life ¯`}{`\\`}{`_`}{`(ツ)`}{`_`}{`/¯`}</p>
    <p>{`Tomorrow, I’ll show you why I think MobX can’t work in our situation, but Redux might.`}</p>
    <p>{`PS: If you wanna help, we’re hiring. Ping me.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      